import gql from 'graphql-tag';

import { useUiQueries } from '../../lib/hooks';
import fetcher from './uiDataFetcher';

const QUERY = gql`
	query uiData_contentTreeNode($curriculumId: String!, $path: ContentTreePath!) {
		uiData {
			contentTreeNode(curriculumId: $curriculumId, path: $path) {
				__typename
				... on ContentTreeActivity {
					color
					contentIds
					curriculumId
					path
				}
				... on ContentTreeLevel {
					activitiesCount
					children
					color
					curriculumId
					label
					learningObjective
					path
					reportDisplayMode
				}
			}
		}
	}
`;

const transformer = (d) => (d.uiData.contentTreeNode);

const useContentTreeNodes = (nodes) => useUiQueries(
	nodes.map(
		([curriculumId, path]) => ({
			document: QUERY,
			variables: { curriculumId, path },
			options: {
				queryKey: ['uiData_contentTreeNode', curriculumId, path],
				transformer: transformer,
			},
		})
	),
	fetcher,
);
export default useContentTreeNodes;
